/**
 * @flow
 * @relayHash db5c5d760521a8ec018e171719a5d578
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteJobYieldInput = {|
  id: string
|};
export type DeleteJobYieldMutationVariables = {|
  input: DeleteJobYieldInput
|};
export type DeleteJobYieldMutationResponse = {|
  +deleteJobYield: {|
    +deletedId: string
  |}
|};
export type DeleteJobYieldMutation = {|
  variables: DeleteJobYieldMutationVariables,
  response: DeleteJobYieldMutationResponse,
|};
*/


/*
mutation DeleteJobYieldMutation(
  $input: DeleteJobYieldInput!
) {
  deleteJobYield(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteJobYieldInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteJobYield",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteJobYieldPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteJobYieldMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteJobYieldMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteJobYieldMutation",
    "id": null,
    "text": "mutation DeleteJobYieldMutation(\n  $input: DeleteJobYieldInput!\n) {\n  deleteJobYield(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'be17c4cd81e4d3e3bfa7a266c41e10bc';
module.exports = node;
